import { mapActions, mapMutations } from 'vuex';
const logViewerMixin = {
	methods: {
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog']),
		...mapActions(['downloadFile']),
		downloadFileFromServer(fileName) {
			this.openLoaderDialog();
			if (fileName) {
				this.downloadFile(fileName).then(_ => {
					this.closeLoaderDialog();
				});
			}
		},
	},
};

export default logViewerMixin;
